//messages.js
export default {
    // ORDERS
    order_id: "Order #",
    order_date: "Order Date",
    ship_date: "Ship Date",
    subtotal: "Subtotal",
    discount: "Discount",
    total_amount: "Total Amount",
    comments: "Comments",
    edit_order: "Edit Order",
    add_order: "Add Order",
    delete_order: "Delete Order",
    delete_order_confirm: "This action is not reversible!",
    orders: "Orders",
    order: "Order",

    order_detail_id: "ID",
    edit_order_detail: "Edit Order Detail",
    add_order_detail: "Add Order Detail",
    delete_order_detail: "Delete Order Detail",
    order_details: "Order Details",
    freight: "Freight",
    customs: "Customs",
    expected_ship_date: "Expected Ship Date",
};
